"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _VirtualBackgroundUploadError = require("./VirtualBackgroundUploadError.styled");
var _Reusable = require("../../../constants/Reusable");
function VirtualBackgroundUploadError(_ref) {
  var errorFile = _ref.errorFile,
    removeFile = _ref.removeFile;
  return /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUploadError.UploadedFiles, {
    "data-testid": "uploaded-files"
  }, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUploadError.ErrorFileLabel, {
    "data-testid": "error-file-label"
  }, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUploadError.FileIcon, {
    icon: _freeSolidSvgIcons.faFileVideo
  }), /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUploadError.FileName, null, " ", errorFile.name, " "), /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUploadError.DeleteIconWrapper, {
    onKeyDown: function onKeyDown(e) {
      return (0, _Reusable.handleEnterDown)(e, removeFile);
    },
    "aria-label": "Delete",
    tabIndex: 0
  }, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUploadError.DeleteIcon, {
    icon: _freeSolidSvgIcons.faCircleXmark,
    "data-testid": "deleteFileIcon",
    onClick: removeFile
  }))), errorFile.errors.map(function (error) {
    return /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUploadError.FileErrors, {
      key: error
    }, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUploadError.ErrorIcon, {
      icon: _freeSolidSvgIcons.faExclamationTriangle
    }), /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUploadError.ErrorText, null, error));
  }));
}
VirtualBackgroundUploadError.propTypes = {
  errorFile: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    errors: _propTypes["default"].array.isRequired
  }),
  removeFile: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = VirtualBackgroundUploadError;